import { render } from "./TachographFilesView.vue?vue&type=template&id=6a9e6dec&ts=true"
import script from "./TachographFilesView.vue?vue&type=script&lang=ts"
export * from "./TachographFilesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__